// removed by extract-text-webpack-plugin
module.exports = {"addAgent":"kyhdZolkYSc1Fz8-up_zm","addIcon":"C_MOLMC00MnxT60UMRaI0","agent":"_2CUQoXs8f0ka07US8GRNb2","selectedAgent":"_2zRYjGSTMojG-ewdC4rBZr _2CUQoXs8f0ka07US8GRNb2","name":"_2wB_JYUKfC_iuKLbUDUM4D"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AgentsList/style.css
// module id = 134
// module chunks = 0